/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConstructorGetPageResponseDto } from '../models';
// @ts-ignore
import type { ConstructorSavePageRequestDto } from '../models';
/**
 * CONSTRUCTORApi - axios parameter creator
 * @export
 */
export const CONSTRUCTORApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение страницы
         * @param {string} key Путь к файлу
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructorControllerGetPage: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('constructorControllerGetPage', 'key', key)
            const localVarPath = `/constructor/getPage/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Загрузка страницы
         * @param {ConstructorSavePageRequestDto} constructorSavePageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructorControllerSavePage: async (constructorSavePageRequestDto: ConstructorSavePageRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'constructorSavePageRequestDto' is not null or undefined
            assertParamExists('constructorControllerSavePage', 'constructorSavePageRequestDto', constructorSavePageRequestDto)
            const localVarPath = `/constructor/savePage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(constructorSavePageRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CONSTRUCTORApi - functional programming interface
 * @export
 */
export const CONSTRUCTORApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CONSTRUCTORApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение страницы
         * @param {string} key Путь к файлу
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async constructorControllerGetPage(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConstructorGetPageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.constructorControllerGetPage(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CONSTRUCTORApi.constructorControllerGetPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Загрузка страницы
         * @param {ConstructorSavePageRequestDto} constructorSavePageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async constructorControllerSavePage(constructorSavePageRequestDto: ConstructorSavePageRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConstructorSavePageRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.constructorControllerSavePage(constructorSavePageRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CONSTRUCTORApi.constructorControllerSavePage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CONSTRUCTORApi - factory interface
 * @export
 */
export const CONSTRUCTORApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CONSTRUCTORApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение страницы
         * @param {string} key Путь к файлу
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructorControllerGetPage(key: string, options?: RawAxiosRequestConfig): AxiosPromise<ConstructorGetPageResponseDto> {
            return localVarFp.constructorControllerGetPage(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Загрузка страницы
         * @param {ConstructorSavePageRequestDto} constructorSavePageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        constructorControllerSavePage(constructorSavePageRequestDto: ConstructorSavePageRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ConstructorSavePageRequestDto> {
            return localVarFp.constructorControllerSavePage(constructorSavePageRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CONSTRUCTORApi - object-oriented interface
 * @export
 * @class CONSTRUCTORApi
 * @extends {BaseAPI}
 */
export class CONSTRUCTORApi extends BaseAPI {
    /**
     * 
     * @summary Получение страницы
     * @param {string} key Путь к файлу
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CONSTRUCTORApi
     */
    public constructorControllerGetPage(key: string, options?: RawAxiosRequestConfig) {
        return CONSTRUCTORApiFp(this.configuration).constructorControllerGetPage(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Загрузка страницы
     * @param {ConstructorSavePageRequestDto} constructorSavePageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CONSTRUCTORApi
     */
    public constructorControllerSavePage(constructorSavePageRequestDto: ConstructorSavePageRequestDto, options?: RawAxiosRequestConfig) {
        return CONSTRUCTORApiFp(this.configuration).constructorControllerSavePage(constructorSavePageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

